export default __webpack_public_path__ + "static/media/cc-add-form.1f51cc7c.jpg";